import React from "react";

/**
 * Replaces the old "Order Confirmation" modal. Shows exactly the rows the modal showed
 * (the caller builds them, already filtered of empty values), then closes the same way:
 * the caller's onClose reloads the page for a fresh booking.
 */
export default function PublicSuccess({ title, subtitle, rows, onClose, closeLabel = "Close" }) {
  return (
    <div className="bstep-card pbk-success" role="status">
      <div className="pbk-success-badge" aria-hidden="true">
        ✓
      </div>
      <h3>{title}</h3>
      {subtitle && <p>{subtitle}</p>}
      <div className="pbk-rows">
        {rows.map((row) => (
          <div key={row.label} className="pbk-row">
            <div className="pbk-row-label">{row.label}</div>
            <div className="pbk-row-value">{row.value}</div>
          </div>
        ))}
      </div>
      <div className="d-flex justify-content-center mt-3">
        <button type="button" className="btn btn-danger px-4" onClick={onClose}>
          {closeLabel}
        </button>
      </div>
    </div>
  );
}
